<template>
    <div class="space-y-4">
        <div class="mb-4 flex items-center justify-between">
            <h2 class="font-title text-sm font-bold uppercase">{{ $t('profile.game_stats') }}</h2>
            <SelectDrawer v-model="selectedPeriod" :presets="periodPresets" class="">
                {{ $t('profile.filter_by_period') }}
            </SelectDrawer>
        </div>
        
        <PlayerStats v-if="!isLoading" :statistics="statistics" :period="selectedPeriod" />
        
        <div v-else class="flex items-center justify-center py-12">
            <div class="text-zinc-400">{{ $t('statistics.loading') }}</div>
        </div>
    </div>
</template>

<script>
import PlayerStats from '@/views/Sections/PlayerStats.vue'
import SelectDrawer from '@/components/ui/SelectDrawer.vue'
import { apiService } from '@/services/api'
import { ANALYTICS_EVENTS } from '@/constants/analyticsEvents.ts'

export default {
    name: 'ProfileStatsTab',
    components: {
        PlayerStats,
        SelectDrawer,
    },
    data() {
        return {
            statistics: null,
            isLoading: true,
            selectedPeriod: 'week',
        }
    },
    computed: {
        periodPresets() {
            return [
                { label: this.$t('statistics.period_week'), value: 'week' },
                { label: this.$t('statistics.period_month'), value: 'month' },
                { label: this.$t('statistics.period_all_time'), value: 'all_time' },
            ]
        },
    },
    watch: {
        async selectedPeriod(period) {
            // Which periods people actually look at - the watcher only runs on a real change,
            // so the initial 'week' default is not counted as a choice.
            this.$analytics.trackEvent(ANALYTICS_EVENTS.STATS_FILTER_CHANGED, {
                period,
                scope: 'profile',
            })

            this.isLoading = true
            try {
                await this.fetchProfileStats()
            } catch (error) {
                console.error('Failed to load profile stats:', error)
            } finally {
                this.isLoading = false
            }
        },
    },
    async mounted() {
        try {
            await this.fetchProfileStats()
        } catch (error) {
            console.error('Failed to load profile stats:', error)
        } finally {
            this.isLoading = false
        }
    },
    methods: {
        async fetchProfileStats() {
            try {
                const url = `/api/v1/profile?period=${encodeURIComponent(this.selectedPeriod)}`
                const response = await apiService.get(url)
                this.statistics = response || null
                return response
            } catch (error) {
                console.error('Failed to fetch profile stats:', error)
                this.statistics = null
                throw error
            }
        },
    }
}
</script>